import React from 'react';
import axios from 'axios';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUsers,
    faArrowRight,
    faPen,
    faTrashCan,
    faPlus,
    faMobileScreenButton,
    faChalkboardUser,
} from '@fortawesome/free-solid-svg-icons';

import { useHistory } from 'react-router-dom';

import { useSelector, useDispatch } from 'react-redux'

import MyModalComponent from './MyModal';
import MyModalComponent2 from './MyModal2';
import MyModalCreateClasse from './ClasseModal/MyModalCreateClasse';
import MyModalDeleteClasse from './ClasseModal/MyModalDeleteClasse';
import MyModalModifClasse from './ClasseModal/MyModalModifClasse';
import MyModalModifDevice from './DeviceModal/MyModalModifDevice';
import MyModalDeleteDevice from './DeviceModal/MyModalDeleteDevice';

export default function CardTable() {

    const history = useHistory();

    const [modalIsOpen, setIsOpen] = React.useState(false);
    const [modalIsOpen2, setIsOpen2] = React.useState(false);
    const [modalIsOpen3, setIsOpen3] = React.useState(false);
    const [modalIsOpen4, setIsOpen4] = React.useState(false);
    const [modalIsOpen5, setIsOpen5] = React.useState(false);
    const [modalIsOpen6, setIsOpen6] = React.useState(false);
    const [modalIsOpen7, setIsOpen7] = React.useState(false);
    
    const [userSelect, setUserSelect] = React.useState('');
    const [classeSelect, setClasseSelect] = React.useState('');
    const [deviceNumber, setDeviceNumber] = React.useState();
    const [isLoadingDevices, setIsLoadingDevices] = React.useState(false);

    const user_connected = useSelector(state => state.userConnected.user_connected)
    const allClasse = useSelector(state => state.classeDetail.arr)
    const allDevice = useSelector(state => state.userDevice)
    const user = useSelector(state => state.userDetail.arr)

    const dispatch = useDispatch()

    React.useEffect(() => {
        let isMounted = true;

        if (user_connected.connected !== true || !user_connected.id_user) {
            setIsLoadingDevices(false);
            return () => {
                isMounted = false;
            };
        }

        setIsLoadingDevices(true);
        axios.get(`https://eps.acces-editions.com/api/getUser?id_user=${user_connected.id_user}`)
            .then((response) => {
                if (!isMounted) return;
                const deviceInfo = response.data?.allInfo?.[0];
                if (deviceInfo?.id_compte) {
                    dispatch({ type: 'user/userDevice', payload: deviceInfo });
                } else {
                    dispatch({ type: 'user/userDeviceClear' });
                }
            })
            .catch(() => {
                if (isMounted) dispatch({ type: 'user/userDeviceClear' });
            })
            .finally(() => {
                if (isMounted) setIsLoadingDevices(false);
            });

        return () => {
            isMounted = false;
        };
    }, [user_connected.connected, user_connected.id_user, dispatch]);

    function disconnectUser() {
        dispatch({ type: 'user/userDisconnect' });
        dispatch({ type: 'user/classeDetail', payload: [] });
        dispatch({ type: 'user/userDeviceClear' });
        dispatch({ type: 'user/eleveDetail', payload: [] });
        dispatch({ type: 'user/eleveNb', payload: { nb_eleve: 0 } });
        dispatch({ type: 'note/noteDetail', payload: [] });
    }
    const devices = [1, 2]
        .filter((deviceIndex) => {
            const deviceName = allDevice.userDevice[`device_name_${deviceIndex}`];
            const macAddress = allDevice.userDevice[`mac_adress_${deviceIndex}`];
            return Boolean(deviceName || macAddress);
        })
        .map((deviceIndex) => ({
            index: deviceIndex,
            name: allDevice.userDevice[`device_name_${deviceIndex}`] || `Appareil ${deviceIndex}`,
            macAddress: allDevice.userDevice[`mac_adress_${deviceIndex}`],
        }));

    function openFromParent(modalNumber, row, deviceNumberParams) {
        switch(modalNumber) {
          case 1:
            setIsOpen(true);
            setUserSelect(row);
            break;
          case 2:
            setIsOpen2(true);
            setUserSelect(row);
            break;
          case 3:
            setIsOpen3(true);
            break;
          case 4:
            setIsOpen4(true);
            setClasseSelect(row);
            break;
          case 5:
            setIsOpen5(true);
            setClasseSelect(row);
            break;
          case 6:
            setIsOpen6(true);
            setDeviceNumber(deviceNumberParams)
            break;
          case 7:
            setIsOpen7(true);
            setDeviceNumber(deviceNumberParams)
            break;
          default:
            break;
        }
    }

    function handleCloseModal(event, data) {
        switch(data) {
          case 1:
            setIsOpen(false);
            break;
          case 2:
            setIsOpen2(false);
            break;
          case 3:
            setIsOpen3(false);
            break;
          case 4:
            setIsOpen4(false);
            break;
          case 5:
            setIsOpen5(false);
            break;
          case 6:
            setIsOpen6(false);
            break;
          case 7:
            setIsOpen7(false);
            break;
          default:
            break;
        }
    }

    return (
        <div>
            <MyModalComponent
                IsModalOpened={modalIsOpen}
                onCloseModal={handleCloseModal}
                user={userSelect}
            />
            <MyModalComponent2
                IsModalOpened={modalIsOpen2}
                onCloseModal={handleCloseModal}
                user={userSelect}
            />
            <MyModalCreateClasse
                IsModalOpened={modalIsOpen3}
                onCloseModal={handleCloseModal}
            />
            <MyModalDeleteClasse
                IsModalOpened={modalIsOpen4}
                onCloseModal={handleCloseModal}
                classe={classeSelect}
            />
            <MyModalModifClasse
                IsModalOpened={modalIsOpen5}
                onCloseModal={handleCloseModal}
                classe={classeSelect}
            />
            <MyModalModifDevice
                IsModalOpened={modalIsOpen6}
                onCloseModal={handleCloseModal}
                deviceInfo={allDevice.userDevice}
                deviceNumberParams={deviceNumber}
            />
            <MyModalDeleteDevice
                IsModalOpened={modalIsOpen7}
                onCloseModal={handleCloseModal}
                deviceInfo={allDevice.userDevice}
                deviceNumberParams={deviceNumber}
            />
            <section className="ae-account-users-card">
                <header className="ae-account-users-heading">
                    <span className="ae-account-users-icon"><FontAwesomeIcon icon={faUsers} /></span>
                    <span>
                        <h2>Liste des utilisateurs</h2>
                        <p>Retrouvez la liste des utilisateurs ayant accès à votre compte.</p>
                    </span>
                </header>

                {user.length > 0 && (user[0].id_user !== "" || user[0].pseudo !== "") ? (
                    <div className="ae-account-table-wrap">
                        <table className="ae-account-users-table">
                            <thead>
                                <tr>
                                    <th>Pseudo</th>
                                    <th>Avatar</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {user
                                    .filter((row) => user_connected.connected !== true || user_connected.id_user === row.id_user)
                                    .map((row) => (
                                    <tr key={row.id_user}>
                                        <td data-label="Pseudo"><strong>{row.pseudo}</strong></td>
                                        <td data-label="Avatar">
                                            <img
                                                className="ae-account-avatar"
                                                src={`${process.env.PUBLIC_URL}/img/avatars/avatar_${row.id_avatar}.png`}
                                                alt={`Avatar de ${row.pseudo}`}
                                            />
                                        </td>
                                        <td data-label="Actions">
                                            <div className="ae-account-row-actions">
                                                {user_connected.connected === true ? (
                                                    <>
                                                        <button className="ae-account-secondary-button" type="button" onClick={() => openFromParent(1, row)}>
                                                            Modifier
                                                        </button>
                                                        <button className="ae-account-connect-button ae-account-connect-button--logout" type="button" onClick={disconnectUser}>
                                                            <span>Se déconnecter</span>
                                                            <FontAwesomeIcon icon={faArrowRight} />
                                                        </button>
                                                    </>
                                                ) : (
                                                    <button className="ae-account-connect-button" type="button" onClick={() => openFromParent(2, row)}>
                                                        <span>Connexion</span>
                                                        <FontAwesomeIcon icon={faArrowRight} />
                                                    </button>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <p className="ae-account-empty">Aucun utilisateur</p>
                )}
            </section>
            <div className="ae-account-extra-content" style={user_connected.connected === true ? { display: 'grid' } : { display: 'none' }}>
                <section className="ae-account-management-card">
                    <header className="ae-account-management-heading">
                        <span className="ae-account-management-icon"><FontAwesomeIcon icon={faChalkboardUser} /></span>
                        <span>
                            <h2>Mes classes</h2>
                            <p>Gérez vos classes et accédez rapidement aux outils associés.</p>
                        </span>
                    </header>

                    {allClasse.length > 0 && allClasse[0].id_classe !== '' ? (
                        <div className="ae-account-data-table-wrap ae-account-classes-table-wrap">
                            <table className="ae-account-data-table ae-account-classes-table">
                                <thead>
                                    <tr>
                                        <th>Nom de la classe</th>
                                        <th>Nom de l'établissement</th>
                                        <th>Niveau(x)</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {allClasse.map((row) => (
                                        <tr key={row.id_classe}>
                                            <td data-label="Classe"><strong>{row.nom_classe}</strong></td>
                                            <td data-label="Établissement">{row.nom_etablissement}</td>
                                            <td data-label="Niveaux">{row.niveau}</td>
                                            <td data-label="Actions">
                                                <div className="ae-account-class-actions">
                                                    <div className="ae-account-icon-actions">
                                                        <button type="button" className="ae-account-outline-icon ae-account-outline-icon--edit" onClick={() => openFromParent(5, row)} aria-label={`Modifier ${row.nom_classe}`}>
                                                            <FontAwesomeIcon icon={faPen} />
                                                        </button>
                                                        <button type="button" className="ae-account-outline-icon ae-account-outline-icon--delete" onClick={() => openFromParent(4, row)} aria-label={`Supprimer ${row.nom_classe}`}>
                                                            <FontAwesomeIcon icon={faTrashCan} />
                                                        </button>
                                                    </div>
                                                    <div className="ae-account-class-tools">
                                                        <button type="button" className="ae-account-tool ae-account-tool--students" onClick={() => history.push({ pathname: '/classe', state: { detail: row } })}>Gestion des élèves</button>
                                                        <button type="button" className="ae-account-tool ae-account-tool--tracking" onClick={() => history.push({ pathname: '/suivi_eval', state: { detail: row } })}>Suivi évaluation</button>
                                                        <button type="button" className="ae-account-tool ae-account-tool--year" onClick={() => history.push({ pathname: '/fil_annuel', state: { detail: row } })}>Fil annuel</button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <p className="ae-account-management-empty">Vous n'avez aucune classe</p>
                    )}

                    <button type="button" className="ae-account-create-class" onClick={() => openFromParent(3, user_connected)}>
                        <FontAwesomeIcon icon={faPlus} />
                        <span>Créer une classe</span>
                    </button>
                </section>

                <section className="ae-account-management-card">
                    <header className="ae-account-management-heading">
                        <span className="ae-account-management-icon"><FontAwesomeIcon icon={faMobileScreenButton} /></span>
                        <span>
                            <h2>Mes appareils</h2>
                            <p>Consultez et gérez les appareils autorisés à accéder à votre compte.</p>
                        </span>
                    </header>

                    {isLoadingDevices ? (
                        <p className="ae-account-management-empty">Chargement des appareils…</p>
                    ) : devices.length > 0 ? (
                        <div className="ae-account-data-table-wrap ae-account-devices-table-wrap">
                            <table className="ae-account-data-table ae-account-devices-table">
                                <thead>
                                    <tr>
                                        <th>Nom appareil</th>
                                        <th>Adresse MAC</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {devices.map((device) => (
                                        <tr key={`${device.name}-${device.index}`}>
                                            <td data-label="Appareil"><strong>{device.name}</strong></td>
                                            <td data-label="Adresse MAC" className="ae-account-mac-address">{device.macAddress}</td>
                                            <td data-label="Actions">
                                                <div className="ae-account-device-actions">
                                                    <button type="button" className="ae-account-device-button ae-account-device-button--edit" onClick={() => openFromParent(6, allDevice.userDevice, device.index)}>
                                                        <FontAwesomeIcon icon={faPen} />
                                                        <span>Modifier</span>
                                                    </button>
                                                    <button type="button" className="ae-account-device-button ae-account-device-button--delete" onClick={() => openFromParent(7, allDevice.userDevice, device.index)}>
                                                        <FontAwesomeIcon icon={faTrashCan} />
                                                        <span>Supprimer</span>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <p className="ae-account-management-empty">Vous n'avez aucun appareil connecté</p>
                    )}
                </section>
            </div>
        </div>
    );
}
